import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

interface JobPostingProgressProps {
  filledCount: number;
  capacity: number;
}

export function JobPostingProgress({ filledCount, capacity }: JobPostingProgressProps) {
  const { t } = useTranslation();

  const percentage = capacity > 0 ? Math.min((filledCount / capacity) * 100, 100) : 0;

  const getBarColor = () => {
    if (percentage > 90) {
      return 'bg-red-500';
    }
    if (percentage >= 75) {
      return 'bg-yellow-500';
    }
    return 'bg-green-500';
  };

  return (
    <div className='w-full'>
      <div className='h-2 rounded-full bg-gray-200'>
        <div className={cn('h-2 rounded-full transition-all', getBarColor())} style={{ width: `${percentage}%` }} />
      </div>
      <p className='mt-1 text-xs text-gray-500'>{t('jobPostings.progress', { filled: filledCount, capacity })}</p>
    </div>
  );
}
